var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReturn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-path": "fill",
    d: "M1.10156 4.75L0.748008 5.10355L0.394455 4.75L0.748008 4.39645L1.10156 4.75ZM4.85156 13.5C4.57542 13.5 4.35156 13.2761 4.35156 13C4.35156 12.7239 4.57542 12.5 4.85156 12.5L4.85156 13.5ZM4.49801 8.85355L0.748008 5.10355L1.45512 4.39645L5.20512 8.14645L4.49801 8.85355ZM0.748008 4.39645L4.49801 0.646447L5.20512 1.35355L1.45512 5.10355L0.748008 4.39645ZM1.10156 4.25L8.97656 4.25L8.97656 5.25L1.10156 5.25L1.10156 4.25ZM8.97656 13.5L4.85156 13.5L4.85156 12.5L8.97656 12.5L8.97656 13.5ZM13.6016 8.875C13.6016 11.4293 11.5309 13.5 8.97656 13.5L8.97656 12.5C10.9786 12.5 12.6016 10.877 12.6016 8.875L13.6016 8.875ZM8.97656 4.25C11.5309 4.25 13.6016 6.32068 13.6016 8.875L12.6016 8.875C12.6016 6.87297 10.9786 5.25 8.97656 5.25L8.97656 4.25Z",
    fill: "#1D1D46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturn);
export default __webpack_public_path__ + "static/media/return.ea171af4b3d41b2d447bc70c253e941a.svg";
export { ForwardRef as ReactComponent };